
export default {
  // Common
  "language": "언어",
  "language_description": "애플리케이션 전체에서 사용되는 언어 변경",
  "save_language": "언어 환경설정 저장",
  "updating": "업데이트 중...",
  "return_home": "홈으로 돌아가기",
  "sign_out": "로그아웃",
  "error": "오류",
  "loading": "로딩 중...",
  "cancel": "취소",
  "save": "저장",
  "edit": "편집",
  "delete": "삭제",
  "back": "뒤로",
  "view_details": "세부 정보 보기",
  "not_applicable": "해당 없음",
  "invalid_date": "유효하지 않은 날짜",
  "name": "이름",
  "qty": "수량",
  "actions": "작업",
  "sort_by": "정렬 기준",
  "filter_by": "필터 기준",
  "ascending": "오름차순",
  "descending": "내림차순",
  "date_added": "추가 날짜",
  "retry": "재시도",
  "with": "사용",
  "or": "또는",
  "format": "포맷",
  "username": "사용자 이름",
  "phone_number": "전화번호",
  "email": "이메일",
  "change": "변경",
  "save_changes": "변경사항 저장",
};
